var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-color"},[_c('h5',{staticClass:"case-color__heading"},[_vm._v("\n\t\tCase Color\n\t")]),_vm._v(" "),_c('div',{staticClass:"case-color__container"},_vm._l((_vm.variantsList),function(variant){
var _obj;
return _c('div',{key:variant.id,staticClass:"case-color__color",class:( _obj = {
				'case-color__color--selected': variant.id === _vm.currentVariantId
			}, _obj[("case-color__color--" + (variant.colors[0].toLowerCase()))] = true, _obj ),on:{"click":function($event){return _vm.selectVariant(variant)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }